import { createSlice } from "@reduxjs/toolkit";
import { getMetrcTransactions } from "./metrcTransactionsActions";

const initialState = {
  loading: false,
  error: null,
  success: false,
  transactions: {},
};

const metrcTransactionsSlice = createSlice({
  name: "metrcTransactions",
  initialState,
  reducers: {
    resetMetrcTransactionError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMetrcTransactions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMetrcTransactions.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.transactions = payload;
      })
      .addCase(getMetrcTransactions.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { resetMetrcTransactionError } = metrcTransactionsSlice.actions;
export default metrcTransactionsSlice.reducer;